import { render } from "./v-select.vue?vue&type=template&id=192b714a&scoped=true"
import script from "./v-select.vue?vue&type=script&lang=js"
export * from "./v-select.vue?vue&type=script&lang=js"

import "./v-select.vue?vue&type=style&index=0&id=192b714a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192b714a"]])

export default __exports__